const actions = {
  SET_USER: "SET_USER",
  SET_TOKEN: "SET_TOKEN",
  SET_LOGGED_IN: "SET_LOGGED_IN",
  SET_LOADING: "SET_LOADING",
  SET_TYPE: "SET_TYPE",
  setUser: (data) => {
    return { type: actions.SET_USER, data };
  },
  setType: (data) => {
    return { type: actions.SET_TYPE, data };
  },
  setToken: (data) => {
    return { type: actions.SET_TOKEN, data };
  },
  setLoggedIn: (data) => {
    return { type: actions.SET_LOGGED_IN, data };
  },
  setLoading: (data) => {
    return {
      type: actions.SET_LOADING,
      data,
    };
  },
};

export default actions;
